import { createAction, props } from '@ngrx/store';

export const setPreviousRoute = createAction('[App][Core] set previous route', props<{ previousRoute: string }>());
